export default __webpack_public_path__ + "static/media/snow_rock.e835fcbf.png";